import React, { useEffect, useState } from 'react'

function getTimeRemainingToTarget() {
  // Data di destinazione: 9 Novembre 2026, 08:00:00 (Mese 10 = Novembre)
  const targetDate = new Date(2026, 10, 9, 8, 0, 0);
  const now = new Date();

  const diffInMs = targetDate - now;

  if (diffInMs <= 0) {
    return [0, 0, 0, 0];
  }

  const totalSeconds = Math.floor(diffInMs / 1000);

  const seconds = totalSeconds % 60;
  const minutes = Math.floor(totalSeconds / 60) % 60;
  const hours = Math.floor(totalSeconds / (60 * 60)) % 24;
  const days = Math.floor(totalSeconds / (60 * 60 * 24));

  return [days, hours, minutes, seconds];
}

const RegistrationBanner = () => {

    const [timeLeft, setTimeLeft] = useState([0, 0, 0, 0]);

    useEffect(()=>{
    setTimeLeft(getTimeRemainingToTarget());

    const timer = setInterval(() => {
      const updatedTime = getTimeRemainingToTarget();
      setTimeLeft(updatedTime);

      if (updatedTime.every((val) => val === 0)) {
        clearInterval(timer);
      }
    }, 1000);
    }, [])

  return (
    <section className='w-screen bg-brand-blue py-20 sm:py-24 md:py-32'>
        <article className='mx-auto'>
            <div className='mx-auto flex flex-col items-center justify-center text-center sm:text-center'>
                <p className='text-brand-black uppercase font-mono uppercase'>// Registrations are open</p>
                <h3 className='font-black text-brand-black uppercase font-display text-[clamp(4rem,7vw,8rem)] leading-none text-balanced'>CHECK-IN STARTS IN</h3>
            </div>

            <div className='flex flex-col sm:flex-row gap-4 sm:gap-8 md:gap-16 justify-center items-center pt-12 sm:py-0'>
                <div className='flex items-end sm:block gap-6'>
                    <h2 className='leading-none font-black text-brand-black uppercase font-display text-8xl sm:text-[clamp(6rem,14vw,16rem)]'>{timeLeft[0]}</h2>
                    <p className='-translate-y-3 sm:translate-y-none text-center font-mono text-lg'>Days</p>
                </div>
                <div className='flex items-end sm:block gap-6'>
                    <h2 className='leading-none font-black text-brand-black uppercase font-display text-8xl sm:text-[clamp(6rem,14vw,16rem)]'>{timeLeft[1]}</h2>
                    <p className='-translate-y-3 sm:translate-y-none text-center font-mono text-lg'>Hours</p>
                </div>
                <div className='flex items-end sm:block gap-6'>
                    <h2 className='leading-none font-black text-brand-black uppercase font-display text-8xl sm:text-[clamp(6rem,14vw,16rem)]'>{timeLeft[2]}</h2>
                    <p className='-translate-y-3 sm:translate-y-none text-center font-mono text-lg'>Minutes</p>
                </div>
                <div className='flex items-end sm:block gap-6'>
                    <h2 className='leading-none font-black text-brand-black uppercase font-display text-8xl sm:text-[clamp(6rem,14vw,16rem)]'>{timeLeft[3]}</h2>
                    <p className='-translate-y-3 sm:translate-y-none text-center font-mono text-lg'>Seconds</p>
                </div>
            </div>
        </article>

        <article className='flex flex-col items-center mt-12'>
            <div className='flex flex-col sm:flex-row gap-6'>
                <button className='black-btn px-5 py-4 text-brand-blue'> 
                    <a href="#iscriviti">[ REGISTER NOW ] </a>
                </button>
                <button className='transparent-black-btn px-5 py-4'> 
                    <a href="#contatti">[ CONTACT US ] </a>
                </button>
            </div>

            <p className='font-mono text-brand-black mt-10 sm:mt-6 text-sm text-center'>November 7, 2026, University of Milano-Bicocca, Piazza dell'Ateneo Nuovo, 20126 Milano MI</p>
        </article>
    </section>
  )
}

export default RegistrationBanner